import { createLogger } from 'libs/end-to-end/src/isomorphic-logger';

export const uiAppLogger = createLogger({ name: 'sigma2-ui' });
